module.exports = __webpack_public_path__ + "static/media/objective.3f3947cf.svg";